import { render } from "./LalaTequilaLogo.vue?vue&type=template&id=76e9a135"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__